import React, { useState, useEffect } from 'react';
import Hero from './Hero/Hero';
import About from './About/About';
import Projects from './Projects/Projects';
import Contact from './Contact/Contact';
import Footer from './Footer/Footer';
import NavBar from './Navbar/NavBar';
import { PortfolioProvider } from '../context/context';
import { heroData, aboutData, projectsData, contactData, footerData } from '../mock/data';
import {Helmet} from "react-helmet";

function App() {
  const [hero, setHero] = useState({});
  const [about, setAbout] = useState({});
  const [projects, setProjects] = useState([]);
  const [contact, setContact] = useState({});
  const [footer, setFooter] = useState({});

  useEffect(() => {
    setHero({ ...heroData });
    setAbout({ ...aboutData });
    setProjects([...projectsData]);
    setContact({ ...contactData });
    setFooter({ ...footerData });
  }, []);

  return (
    <div className="application">
      <Helmet>
          <meta charSet="utf-8" />
          <title>Damodar Subedi</title>
          <meta name="description" content="This is Portfolio Website of Damodar Subedi, graduated from Islington College and London Metropolitan University" />
          <link rel="canonical" href="https://damodarsubedi.netlify.app/" />
      </Helmet>
      <body>
        
            <NavBar/>
            <PortfolioProvider value={{ hero, about, projects, contact, footer }}>
              <Hero />
              <About />
              <Projects />
              <Contact />
              <Footer />
            </PortfolioProvider>
            </body>
    </div>
    
  );
}

export default App;
